import React from "react";
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import './Links.css';

class GIELink extends React.Component<any, any> {
    render() {
      const {
        children,
        arrowBefore,
        arrowAfter,
        labelClass,
        className,
        ...otherProps // Ici se trouvent target, href, id, onClick, style, etc.
      } = this.props;

        return (
          <a {...otherProps} className={`gie-link ${className}`}>
              {arrowBefore === true ? (<KeyboardArrowLeftIcon className="gie-link-icon"/>) : null}
              <span className={labelClass}>{children}</span>
              {arrowAfter === true ? (<KeyboardArrowRightIcon className="gie-link-icon"/>) : null}
          </a>
        )
    }
}

export default GIELink;
